import React from "react";
import Button from "../../../Button";
import { GiftCardPurchaseOption } from "../../../../types/gift-card";
import BottomPanel from "../../../common/BottomPanel";
import styled from "styled-components";
import { breakpoints } from "../../../../utils/styles";
import WalletBuyAmountInput from "./WalletBuyAmountInput";
import { PictureWithSources } from "../../../common/PictureWithSources";

const BodyContainer = styled.div`
    @media screen and (min-width: ${breakpoints.desktop}px) {
        max-width: 21rem;
    }
`;

const CardPicture = styled(PictureWithSources)`
    display: block;
    margin-bottom: var(--pad-y);
`;

interface Props {
    selectedCard: GiftCardPurchaseOption;
    onClose: () => void;
    setCustomAmount: (amount: number | null) => void;
    setIsGift: (isGift: boolean) => void;
}

const WalletBuyItemDetail: React.FC<Props> = ({
    selectedCard,
    setCustomAmount,
    setIsGift,
    onClose,
}) => {
    const [amount, setAmount] = React.useState<number | null>(null);
    const title = selectedCard.isVariablePrice
        ? <>{selectedCard.name}<br />Ingresa el monto</>
        : selectedCard.name;

    function onSubmit(isGift: boolean) {
        selectedCard.isVariablePrice && setCustomAmount(amount);
        setIsGift(isGift);
    }

    const canSubmit = selectedCard.isVariablePrice ? amount !== null : true;

    return (
        <BottomPanel onClose={onClose} title={title} desktopInline open>
            <BodyContainer>
                {selectedCard.isVariablePrice && (
                    <WalletBuyAmountInput
                        selectedDesign={selectedCard}
                        onSubmit={setAmount}
                    />
                )}
                {!selectedCard.isVariablePrice && (
                    <CardPicture
                        images={selectedCard.images && selectedCard.images.image_medium ? selectedCard.images.image_medium : undefined}
                        fallback={selectedCard.image}
                        title={selectedCard.name}
                    />
                )}

                {selectedCard.description && <p>{selectedCard.description}</p>}
            </BodyContainer>

            <BodyContainer>
                <Button
                    primary
                    block
                    disabled={!canSubmit}
                    onClick={() => onSubmit(false)}
                    className="mb-3"
                >
                    Comprar para mí
                </Button>
                <Button
                    block
                    disabled={!canSubmit}
                    onClick={() => onSubmit(true)}
                >
                    Comprar para regalar
                </Button>
            </BodyContainer>
        </BottomPanel>
    );
};

export default WalletBuyItemDetail;
